/* VELYA — scripts du thème (sans dépendance) */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || {};
  var strings = theme.strings || {};

  /* ---------- Utilitaires ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '{{amount_with_comma_separator}} €';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('.toast');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 2600);
  }

  function lockScroll(lock) { document.body.classList.toggle('is-locked', lock); }

  var focusableSel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function trapFocus(container, event) {
    if (event.key !== 'Tab') return;
    var items = Array.prototype.filter.call(container.querySelectorAll(focusableSel), function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 300);
    });
  }

  /* ---------- Apparition au défilement ---------- */
  function initReveal(root) {
    var html = document.documentElement;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (html.hasAttribute('data-animations') && !reduce && 'IntersectionObserver' in window && !window.Shopify?.designMode) html.classList.add('has-animations');
    var els = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!html.classList.contains('has-animations')) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Bandeau ---------- */
  class AnnouncementSlider extends HTMLElement {
    connectedCallback() {
      var items = this.querySelectorAll('.announcement__item');
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var i = 0, delay = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, delay);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }

  /* ---------- En-tête / menu mobile ---------- */
  class HeaderComponent extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.menu = this.querySelector('[data-mobile-menu]');
      this.opener = this.querySelector('[data-menu-open]');
      if (this.opener) this.opener.addEventListener('click', function () { self.open(); });
      this.querySelectorAll('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(); }); });
      this.onKey = function (e) { if (e.key === 'Escape') self.close(); else trapFocus(self.menu, e); };

      this.querySelectorAll('[data-cart-toggle]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && theme.cartType === 'drawer') { e.preventDefault(); drawer.open(link); }
        });
      });
    }
    open() {
      if (!this.menu) return;
      this.menu.hidden = false;
      requestAnimationFrame(() => this.menu.classList.add('is-open'));
      this.opener.setAttribute('aria-expanded', 'true');
      lockScroll(true);
      document.addEventListener('keydown', this.onKey);
      var first = this.menu.querySelector(focusableSel);
      if (first) first.focus();
    }
    close() {
      if (!this.menu || this.menu.hidden) return;
      this.menu.classList.remove('is-open');
      this.opener.setAttribute('aria-expanded', 'false');
      lockScroll(false);
      document.removeEventListener('keydown', this.onKey);
      setTimeout(() => { this.menu.hidden = true; }, 400);
      this.opener.focus();
    }
  }

  /* ---------- Quantité ---------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.querySelectorAll('button').forEach((btn) => {
        btn.addEventListener('click', () => {
          var min = parseInt(this.input.min, 10) || 0;
          var value = parseInt(this.input.value, 10) || 0;
          value = btn.name === 'plus' ? value + 1 : Math.max(min, value - 1);
          this.input.value = value;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }

  /* ---------- Panier latéral ---------- */
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.bind();
      this.onKey = (e) => { if (e.key === 'Escape') this.close(); else trapFocus(this.querySelector('.drawer__panel'), e); };
    }
    bind() {
      this.querySelectorAll('[data-drawer-close]').forEach((el) => {
        el.addEventListener('click', (e) => {
          if (el.tagName === 'A' && el.getAttribute('href') && !el.classList.contains('drawer__overlay')) {
            // lien « continuer mes achats » : fermer seulement si on reste sur la page
            if (location.pathname === new URL(el.href).pathname) e.preventDefault();
          }
          this.close();
        });
      });
      bindCartLines(this, 'cart-drawer', (sections) => this.renderSections(sections));
    }
    open(opener) {
      this.opener = opener || document.activeElement;
      this.hidden = false;
      requestAnimationFrame(() => this.classList.add('is-open'));
      lockScroll(true);
      document.addEventListener('keydown', this.onKey);
      setTimeout(() => { var p = this.querySelector('.drawer__panel'); if (p) p.focus(); }, 50);
    }
    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      lockScroll(false);
      document.removeEventListener('keydown', this.onKey);
      setTimeout(() => { this.hidden = true; }, 450);
      if (this.opener && this.opener.focus) this.opener.focus();
    }
    renderSections(sections) {
      if (!sections || !sections['cart-drawer']) return this.refresh();
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawerInner');
      var current = this.querySelector('#CartDrawerInner');
      if (fresh && current) { current.replaceWith(fresh); this.bind(); }
    }
    refresh() {
      return fetch(routes.root + '?sections=cart-drawer')
        .then((r) => r.json())
        .then((s) => this.renderSections(s));
    }
  }

  function bindCartLines(container, sectionId, render) {
    function change(key, quantity) {
      var line = container.querySelector('.cart-line[data-line-key="' + CSS.escape(key) + '"]');
      if (line) line.classList.add('is-updating');
      fetch(routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity, sections: [sectionId], sections_url: location.pathname })
      })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error);
          updateCartCount(res.data.item_count);
          render(res.data.sections);
        })
        .catch(function (err) {
          if (line) line.classList.remove('is-updating');
          toast(err.message || strings.error);
        });
    }
    container.querySelectorAll('input[data-line-key]').forEach(function (input) {
      input.addEventListener('change', function () {
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        change(input.dataset.lineKey, q);
      });
    });
    container.querySelectorAll('[data-remove-key]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); change(a.dataset.removeKey, 0); });
    });
    var note = container.querySelector('[data-cart-note]');
    if (note) {
      note.addEventListener('change', function () {
        fetch(routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
      });
    }
  }

  function initCartPage() {
    var page = document.querySelector('[data-cart-page]');
    if (!page) return;
    var sectionId = page.dataset.sectionId;
    if (!sectionId) return;
    function render(sections) {
      if (!sections || !sections[sectionId]) return location.reload();
      var doc = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      var fresh = doc.querySelector('#CartPageInner');
      var current = page.querySelector('#CartPageInner');
      if (fresh && current) {
        current.replaceWith(fresh);
        page.querySelectorAll('quantity-input').forEach(function () {});
        bindCartLines(page, sectionId, render);
      } else {
        location.reload();
      }
    }
    bindCartLines(page, sectionId, render);
  }

  /* ---------- Galerie produit ---------- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('.gallery__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.dots = Array.from(this.querySelectorAll('.gallery__dot'));
      this.dialog = this.querySelector('[data-zoom-dialog]');

      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(parseInt(t.dataset.thumb, 10))));

      if (this.track && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio > 0.6) this.setActive(parseInt(entry.target.dataset.index, 10));
          });
        }, { root: this.track, threshold: [0.6] });
        this.slides.forEach((s) => io.observe(s));
      }

      var initial = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (initial > 0) this.goTo(initial, true);

      if (this.dialog) {
        this.querySelectorAll('[data-open-zoom]').forEach((btn) => {
          btn.addEventListener('click', () => this.openZoom(parseInt(btn.dataset.openZoom, 10)));
        });
        this.dialog.querySelector('[data-zoom-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => lockScroll(false));
        this.dialog.querySelectorAll('.zoom__item').forEach((item) => {
          item.addEventListener('click', (e) => {
            var rect = item.getBoundingClientRect();
            item.style.setProperty('--zx', ((e.clientX - rect.left) / rect.width * 100) + '%');
            item.style.setProperty('--zy', ((e.clientY - rect.top) / rect.height * 100) + '%');
            item.classList.toggle('is-zoomed');
          });
          item.addEventListener('mousemove', (e) => {
            if (!item.classList.contains('is-zoomed')) return;
            var rect = item.getBoundingClientRect();
            item.style.setProperty('--zx', ((e.clientX - rect.left) / rect.width * 100) + '%');
            item.style.setProperty('--zy', ((e.clientY - rect.top) / rect.height * 100) + '%');
          });
        });
      }
    }
    setActive(index) {
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      this.thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      // met en pause les vidéos qui ne sont plus visibles
      this.slides.forEach((s, i) => { if (i !== index) s.querySelectorAll('video').forEach((v) => v.pause()); });
    }
    goTo(index, instant) {
      var slide = this.slides[index];
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      this.setActive(index);
    }
    goToMedia(mediaId) {
      var index = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (index > -1) this.goTo(index);
    }
    openZoom(index) {
      if (!this.dialog.showModal) return;
      this.dialog.showModal();
      lockScroll(true);
      var target = this.dialog.querySelector('[data-zoom-index="' + index + '"]');
      if (target) target.scrollIntoView({ block: 'start' });
    }
  }

  /* ---------- Formulaire produit ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      var data = this.querySelector('[data-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest('[data-section-id]') || document;
      this.idInput = this.form.querySelector('[data-variant-id]');
      this.qtyInput = this.form.querySelector('[data-quantity]');
      this.button = this.form.querySelector('[data-add-button]');
      this.errorEl = this.form.querySelector('[data-form-error]');
      this.fieldsets = Array.from(this.form.querySelectorAll('.variant-picker'));

      this.form.addEventListener('change', (e) => {
        if (e.target.closest('.variant-picker')) this.onVariantChange();
        if (e.target.matches('[data-offer-qty]') && this.qtyInput) this.qtyInput.value = e.target.dataset.offerQty;
      });
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.updateAvailability();
    }
    selectedOptions() {
      return this.fieldsets.map((fs) => {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    currentVariant() {
      var selected = this.selectedOptions();
      if (!selected.length) return this.variants[0];
      return this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    }
    updateAvailability() {
      var selected = this.selectedOptions();
      this.fieldsets.forEach((fs, index) => {
        fs.querySelectorAll('input').forEach((input) => {
          var available = this.variants.some((v) => v.available && v.options[index] === input.value &&
            v.options.every((opt, i) => i === index || selected[i] == null || opt === selected[i]));
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    }
    onVariantChange() {
      var variant = this.currentVariant();
      this.fieldsets.forEach((fs) => {
        var checked = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-selected-value]');
        if (checked && out) out.textContent = checked.value;
      });
      this.updateAvailability();
      this.setError('');

      var label = this.button.querySelector('[data-add-label]');
      var sticky = this.section.querySelector('[data-sticky-button]');
      if (!variant) {
        this.button.disabled = true;
        label.textContent = strings.unavailable;
        if (sticky) { sticky.disabled = true; sticky.textContent = strings.unavailable; }
        return;
      }
      this.idInput.value = variant.id;
      this.button.disabled = !variant.available;
      label.textContent = variant.available ? strings.addToCart : strings.soldOut;
      if (sticky) { sticky.disabled = !variant.available; sticky.textContent = label.textContent; }

      // prix
      this.section.querySelectorAll('[data-price]').forEach((price) => {
        var current = price.querySelector('.price__current');
        var compare = price.querySelector('.price__compare');
        if (current) current.textContent = variant.price_formatted;
        var onSale = variant.compare_at_price > variant.price;
        price.classList.toggle('price--sale', onSale && !!compare);
        if (compare) { compare.hidden = !onSale; var amt = compare.querySelector('[data-compare-amount]'); if (amt) amt.textContent = variant.compare_formatted; }
      });
      var stickyPrice = this.section.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
      var single = this.form.querySelector('[data-offer-single]');
      if (single) single.textContent = variant.price_formatted;
      var double = this.form.querySelector('[data-offer-double]');
      if (double) double.textContent = formatMoney(variant.price * 2);

      // stock faible (inventaire réel Shopify uniquement)
      var low = this.form.querySelector('[data-low-stock]');
      if (low) low.textContent = variant.low_stock > 0 ? (strings.lowStock || '').replace('[count]', variant.low_stock) : '';

      // média associé
      var gallery = this.section.querySelector('media-gallery');
      if (gallery && variant.media_id && gallery.goToMedia) gallery.goToMedia(variant.media_id);

      // URL partageable (page produit uniquement)
      if (document.body.classList.contains('template-product')) {
        var url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
    setError(msg) {
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = !msg;
    }
    onSubmit(e) {
      if (theme.cartType !== 'drawer' || !window.fetch) return; // repli natif : envoi classique du formulaire
      e.preventDefault();
      if (this.button.disabled || this.button.classList.contains('is-loading')) return;
      this.button.classList.add('is-loading');
      this.button.setAttribute('aria-busy', 'true');
      this.setError('');

      var body = new FormData(this.form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', location.pathname);

      fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: body })
        .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
        .then((res) => {
          if (!res.ok) throw new Error(res.data.description || res.data.message || strings.error);
          var drawer = document.querySelector('cart-drawer');
          return fetch(routes.cart + '.js').then((r) => r.json()).then((cart) => {
            updateCartCount(cart.item_count);
            if (drawer) {
              drawer.renderSections(res.data.sections);
              drawer.open(this.button);
            } else {
              toast(strings.added);
            }
          });
        })
        .catch((err) => this.setError(err.message || strings.error))
        .finally(() => {
          this.button.classList.remove('is-loading');
          this.button.removeAttribute('aria-busy');
        });
    }
  }

  /* ---------- Barre d'achat fixe (mobile) ---------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      var form = document.getElementById(this.dataset.target);
      if (!form || !('IntersectionObserver' in window)) return;
      var anchor = form.querySelector('[data-add-button]') || form;
      this.hidden = false;
      var update = () => {
        var a = anchor.getBoundingClientRect();
        var inView = a.bottom > 0 && a.top < window.innerHeight;
        // visible dès que le bouton principal n'est plus à l'écran (au-delà du haut de page)
        this.classList.toggle('is-visible', !inView && window.scrollY > 500);
      };
      new IntersectionObserver(update).observe(anchor);
      window.addEventListener('scroll', () => { if (!this.ticking) { this.ticking = true; requestAnimationFrame(() => { update(); this.ticking = false; }); } }, { passive: true });
    }
  }

  /* ---------- Vidéo YouTube / Vimeo différée ---------- */
  class DeferredVideo extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (btn) btn.addEventListener('click', () => this.load(), { once: true });
    }
    load() {
      var id = encodeURIComponent(this.dataset.id), src;
      if (this.dataset.type === 'youtube') src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      else src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = this.dataset.title || 'Vidéo';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      this.innerHTML = '';
      this.appendChild(iframe);
    }
  }

  /* ---------- Bannière cookies (API Customer Privacy Shopify) ---------- */
  class CookieBanner extends HTMLElement {
    connectedCallback() {
      if (!window.Shopify || !window.Shopify.loadFeatures) return;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) return;
        this.api = window.Shopify.customerPrivacy;
        if (this.api && this.api.shouldShowBanner && this.api.shouldShowBanner()) this.show();
      });
      this.querySelector('[data-cookie="accept"]').addEventListener('click', () => this.save(true, true, true));
      this.querySelector('[data-cookie="decline"]').addEventListener('click', () => this.save(false, false, false));
      this.querySelector('[data-cookie="customize"]').addEventListener('click', (e) => {
        this.querySelector('[data-cookie-prefs]').hidden = false;
        e.currentTarget.hidden = true;
        this.querySelector('[data-cookie="save"]').hidden = false;
      });
      this.querySelector('[data-cookie="save"]').addEventListener('click', () => {
        var get = (k) => !!this.querySelector('[data-consent="' + k + '"]').checked;
        this.save(get('analytics'), get('marketing'), get('preferences'));
      });
    }
    show() { this.hidden = false; }
    save(analytics, marketing, preferences) {
      if (!this.api) { this.hidden = true; return; }
      this.api.setTrackingConsent({ analytics: analytics, marketing: marketing, preferences: preferences, sale_of_data: marketing }, () => { this.hidden = true; });
    }
  }

  function initCookiePreferencesLink() {
    document.querySelectorAll('[data-cookie-preferences]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.privacyBanner && window.privacyBanner.showPreferences) { window.privacyBanner.showPreferences(); return; }
        var banner = document.querySelector('cookie-banner');
        if (banner) { banner.show(); return; }
        location.href = '/policies/privacy-policy';
      });
    });
  }

  /* ---------- Enregistrement ---------- */
  function define(name, ctor) { if (!customElements.get(name)) customElements.define(name, ctor); }
  define('announcement-slider', AnnouncementSlider);
  define('header-component', HeaderComponent);
  define('quantity-input', QuantityInput);
  define('cart-drawer', CartDrawer);
  define('media-gallery', MediaGallery);
  define('product-form', ProductForm);
  define('sticky-atc', StickyAtc);
  define('deferred-video', DeferredVideo);
  define('cookie-banner', CookieBanner);

  function init() {
    initReveal();
    initCartPage();
    initCookiePreferencesLink();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Éditeur de thème : réinitialiser les animations des sections rechargées
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
